<template>
    <div class="px-10 md:px-20 flex flex-col justify-center items-center h-full">
        <alert ref="alert"></alert>

        <div>
            <p class="text-2xl md:text-4xl font-light">
                {{ $t('do_you_want_to_create_a_schedule_to_synchronize') }}
            </p>

            <div class="mt-5">
                {{ $t('the_schedule_will_be_created_to_run_at') }}
                <div class="mt-5">
                    {{ on }}
                </div>
            </div>

            <div class="mt-10">
                <button class="btn btn-orange" :disabled="loading" @click="createSchedule()">
                    {{ $t('yes_create_schedule') }}
                </button>

                <button class="btn mt-2" @click="goBack()" :disabled="loading">
                    {{ $t('no_go_back') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import {Zapin} from "@/services/Api";
    import {dt} from "@/i18n";

    export default {
        props: {
            id: String,
            chat: String
        },

        data() {
            return {
                loading: false,
                on: null,
                update: null
            }
        },

        beforeDestroy() {
            if(this.update)
                clearInterval(this.update);
        },

        mounted() {
            this.on = dt().add(5, 'minutes').format('L LT');

            this.update = setInterval(() => {
                this.on = dt().add(5, 'minutes').format('L LT');
            }, 1000);
        },

        methods: {
            goBack() {
                history.go(-1);
            },

            createSchedule() {
                this.loading = true;

                Zapin
                    .schedules()
                    .forSync(this.id, this.chat, {
                        add_minutes: 5
                    })
                    .then(() => {
                        this.$router.push({
                            name: 'Schedules'
                        });
                    })
                    .catch(err => {
                        if(err.status === 422) {
                            this.$refs.alert.showValidationErrors(err.data);
                        } else {
                            this.$refs.alert.show(this.$t('unknown_error_try_again'));
                        }
                    })
                    .finally(() => this.loading = false);
            }
        }
    }
</script>